module.exports = __webpack_public_path__ + "img/preview_common.994d3a2e.png";